<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/admin/documentation" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Dokument bearbeiten</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newDocumentForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6 form-div">
                <b-form-group id="fieldset-horizontal">
                  <vue-dropzone
                    name="categoryPictures"
                    ref="uploadDocumentFile"
                    id="example-input-0 dropzone"
                    :useCustomSlot="true"
                    :options="dropzoneOptions"
                    @vdropzone-file-added="(file) => uploadFile(file)"
                    @vdropzone-removed-file="handleRemoveFile"
                    aria-describedby="input-0-live-feedback"
                  >
                    <div class="dropzone dropzone-default" id="kt_dropzone_1">
                      <div class="dropzone-msg dz-message needsclick">
                        <h4>Bitte ein Dokument hochladen</h4>
                        <h5>Datei hierhin ziehen oder klicken zum Upload</h5>
                        <p>
                          Erlaubte Formate: PDF
                          <br />Maximale Upload-Größe: 10MB
                        </p>
                      </div>
                    </div>
                  </vue-dropzone>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Der Kategorie-Name ist erforderlich',
                    }"
                  >
                    <v-text-field
                      autocomplete="new-password"
                      v-model="form.documentTitle"
                      :error-messages="errors[0]"
                      label="Titel des Dokuments"
                      outlined
                    ></v-text-field>
                    <span class="form-errors">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group>
                  <v-switch
                    v-model="status"
                    inset
                    :label="status == true ? 'Aktiviert' : 'Deaktiviert'"
                    class="d-inline-block"
                  ></v-switch>
                </b-form-group>

                <div class="fo-row-btn text-right">
                  <v-btn class="submit-btn-fill-outline" @click="goToBack">
                    Abbrechen
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
    <notifications group="documents" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import adminAPI from "@/api/admin";
import config from "@/config/app";
import HtmlClass from "@/core/services/htmlclass.service";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
Vue.use(Notifications);
export default {
  name: "AddCategory",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      this.editDocuments();
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      dropzoneOptions: {
        url: config.API_URL + "add-category",
        thumbnailWidth: 150,
        maxFilesize: 10,
        maxFiles: 1,
        addRemoveLinks: true,
        autoProcessQueue: false,
        timeout: 20000000,
        acceptedFiles: ".pdf, .PDF",
        uploadMultiple: false,
      },
      submitText: "Speichern",
      formError: false,
      userId: null,
      formData: [],
      btnDisable: false,
      status: true,
      oldFile: "",
      fileChanged: "0",
      form: {
        file: null,
        documentTitle: null,
      },
    };
  },
  methods: {
    editDocuments() {
      adminAPI
        .editDocument({ id: this.$route.params.id })
        .then((response) => {
          if (response.status == "success") {
            this.form.documentTitle = response.data.title;
            this.status = response.data.is_status === "1" ? true : false;
            if (response.data.file_path.indexOf(".pdf") !== -1) {
              var file = {
                size: 12345,
                name: response.data.file_name,
                type: "application/pdf",
              };
              this.$refs.uploadDocumentFile.manuallyAddFile(
                file,
                response.data.file_path
              );
            }
            this.oldFile = response.data.file_path;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          } else {
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          }
        })
        .catch((err) => {
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
        });
    },
    goToBack() {
      this.$router.push({ name: "documentation" });
    },
    handleRemoveFile() {
      this.form.file = null;
      this.oldFile = null;
    },
    uploadFile(file) {
      setTimeout(() => {
        if (file.status == "queued") {
            this.fileChanged = "1"
          this.form.file = file;
        }
      }, 1000);
    },
    onSubmit() {
      this.$refs.newDocumentForm.validate().then((success) => {
        if (success) {
          if (this.form.file !== null || this.oldFile) {
            this.btnDisable = true;
            this.submitText = "Wird gespeichert...";
            let fd = new FormData();
            fd.append("id", this.$route.params.id);
            fd.append("user_id", this.currentUser.id);
            fd.append("title", this.form.documentTitle);
            fd.append("file", this.form.file);
            fd.append("file_changed", this.fileChanged);
            fd.append("status", this.status == true ? "1" : "0");

            setTimeout(() => {
              adminAPI
                .updateDocument(fd)
                .then((response) => {
                  if (response.status == "success") {
                    this.submitText = "Speichern";
                    this.btnDisable = false;
                    this.$notify({
                      group: "documents",
                      type: "success",
                      position: "bottom right",
                      text: response.msg,
                      duration: 5000,
                    });
                    setTimeout(() => {
                      this.$router.push({ name: "documentation" });
                    }, 2000);
                  } else {
                    this.btnDisable = false;
                    this.submitText = "Speichern";

                    this.$notify({
                      group: "documents",
                      type: "error",
                      position: "bottom right",
                      text: response.msg,
                      duration: 5000,
                    });
                  }
                })
                .catch((err) => {
                  this.btnDisable = false;
                  this.submitText = "Speichern";
                  this.$notify({
                    group: "documents",
                    type: "error",
                    position: "bottom right",
                    text: err,
                    duration: 5000,
                  });
                });
            }, 2000);
          } else {
            this.$notify({
              group: "documents",
              type: "error",
              position: "bottom right",
              text: "Bitte ein Dokument hochladen",
              duration: 5000,
            });
          }
        } else {
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Speichern";
        }
      });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },

    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}
.form-div {
  margin: auto;
}
.form-errors {
  color: red;
}
.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
